var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortBy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.02705 13.4231H0.973145V15.7196H12.0459V13.4231H1.02705ZM5.4691 0.334182V0.280273H0.973145V2.57677H5.4691V0.334182ZM1.02705 6.84631H0.973145V9.14281H8.75751V6.84631H1.02705Z",
    fill: "#0096D6",
    stroke: "#0096D6",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0271 3.77354H18.4179V7.22367H16.639V3.77354H14.0298L14.0945 3.69806L17.5015 0.312618L17.5338 0.280273L17.5554 0.312618L20.9516 3.69806L21.0271 3.77354Z",
    fill: "#0096D6",
    stroke: "#0096D6",
    strokeWidth: 0.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0271 12.2157L20.9516 12.302L17.5554 15.6874L17.5338 15.7198L17.5015 15.6874L14.0945 12.302L14.0298 12.2157H16.639V8.77637H18.4179V12.2157H21.0271Z",
    fill: "#0096D6",
    stroke: "#0096D6",
    strokeWidth: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortBy);
export default __webpack_public_path__ + "static/media/sort-by.85ace51b726606776260e4d16ec8ec8e.svg";
export { ForwardRef as ReactComponent };